<template>
  <b-row>
    <b-col cols="12">
      <leave-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import LeaveEditForm from './LeaveEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    LeaveEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
